import { t } from "i18next";
import { Controller, useFormContext } from "react-hook-form";
import { Input } from "ui";

import {
  ProductDetailsAttributesBlockProps,
  ProductFormValues
} from "../ProductDetailsForm.types";

import styles from "../ProductDetailsForm.module.scss";

export const ProductDetailsAttributesBlock = ({
  productDetailsAttributes
}: ProductDetailsAttributesBlockProps) => {
  const { control } = useFormContext<ProductFormValues>();

  return (
    <div className={styles.productForm__block}>
      <h4 className={styles.productForm__block__title}>
        {t("Product Details")}
      </h4>

      <div className={styles.productForm__block__box}>
        {productDetailsAttributes.map((attribute, index) => (
          <Controller
            key={attribute.id}
            control={control}
            name={`relatedAttributesValues.${index}`}
            defaultValue={{
              attributeId: String(attribute.id),
              value: ""
            }}
            render={({ field: { value, onChange }, formState: { errors } }) => (
              <Input
                value={value?.value || ""}
                onChange={(e) =>
                  onChange({
                    attributeId: attribute.id,
                    value: e.target.value
                  })
                }
                placeholder={t("Enter value")}
                label={attribute.name}
                maxLength={20}
                preventConsecutiveSpaces={true}
                errorMessage={
                  errors?.relatedAttributesValues
                    ? errors?.relatedAttributesValues[index]?.value?.message
                    : undefined
                }
              />
            )}
          />
        ))}
      </div>
    </div>
  );
};
